import { vars } from '@etg/wings';

export const getStepGradient = (currentStep: number, numberOfSteps: number) => {
  const breakpoint = (currentStep / numberOfSteps) * 100;
  return [
    `${vars.colors.decoration.dark} 0%`,
    `${vars.colors.decoration.dark} calc(${breakpoint}% + 14px)`,
    `${vars.colors.decoration.light} calc(${breakpoint}% + 14px)`,
  ].join(',');
};
